// extracted by mini-css-extract-plugin
module.exports = {"container":"My-z","copyContainer":"Ny-z"};